export interface States {
  abbreviation: string;
  name: string;
  country: string;
  countryAbbrevation?: string;
}

export const STATES: States[] = [
  {
    abbreviation: 'AL',
    name: 'Alabama',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'AK',
    name: 'Alaska',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'AZ',
    name: 'Arizona',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'AR',
    name: 'Arkansas',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'CA',
    name: 'California',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'CO',
    name: 'Colorado',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'CT',
    name: 'Connecticut',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'DE',
    name: 'Delaware',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'DC',
    name: 'District of Columbia',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'FL',
    name: 'Florida',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'GA',
    name: 'Georgia',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'HI',
    name: 'Hawaii',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'ID',
    name: 'Idaho',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'IL',
    name: 'Illinois',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'IN',
    name: 'Indiana',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'IA',
    name: 'Iowa',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'KS',
    name: 'Kansas',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'KY',
    name: 'Kentucky',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'LA',
    name: 'Louisiana',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'ME',
    name: 'Maine',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MD',
    name: 'Maryland',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MA',
    name: 'Massachusetts',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MI',
    name: 'Michigan',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MN',
    name: 'Minnesota',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MS',
    name: 'Mississippi',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MO',
    name: 'Missouri',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'MT',
    name: 'Montana',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NE',
    name: 'Nebraska',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NV',
    name: 'Nevada',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NH',
    name: 'New Hampshire',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NJ',
    name: 'New Jersey',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NM',
    name: 'New Mexico',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NY',
    name: 'New York',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'NC',
    name: 'North Carolina',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'ND',
    name: 'North Dakota',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'OH',
    name: 'Ohio',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'OK',
    name: 'Oklahoma',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'OR',
    name: 'Oregon',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'PA',
    name: 'Pennsylvania',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'RI',
    name: 'Rhode Island',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'SC',
    name: 'South Carolina',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'SD',
    name: 'South Dakota',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'TN',
    name: 'Tennessee',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'TX',
    name: 'Texas',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'UT',
    name: 'Utah',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'VT',
    name: 'Vermont',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'VA',
    name: 'Virginia',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'WA',
    name: 'Washington',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'WV',
    name: 'West Virginia',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'WI',
    name: 'Wisconsin',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'WY',
    name: 'Wyoming',
    country: 'United States',
    countryAbbrevation: 'US',
  },
  {
    abbreviation: 'AB',
    name: 'Alberta',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'BC',
    name: 'British Columbia',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'MB',
    name: 'Manitoba',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'NB',
    name: 'New Brunswick',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'NF',
    name: 'Newfoundland',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'NT',
    name: 'Northwest Territory',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'NS',
    name: 'Nova Scotia',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'NU',
    name: 'Nunavut',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'ON',
    name: 'Ontario',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'PE',
    name: 'Prince Edward Island',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'QC',
    name: 'Quebec',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'SK',
    name: 'Saskatchewan',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'YT',
    name: 'Yukon Territory',
    country: 'Canada',
    countryAbbrevation: 'CA',
  },
  {
    abbreviation: 'AG',
    name: 'Aguascalientes',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'BJ',
    name: 'Baja California',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'BS',
    name: 'Baja California Sur',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'CP',
    name: 'Campeche',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'CH',
    name: 'Chiapas',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'CI',
    name: 'Chihuahua',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'CU',
    name: 'Coahuila',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'CL',
    name: 'Colima',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'DF',
    name: 'Distrito Federal',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'DG',
    name: 'Durango',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'GJ',
    name: 'Guanajuato',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'GR',
    name: 'Guerrero',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'HG',
    name: 'Hidalgo',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'JA',
    name: 'Jalisco',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'EM',
    name: 'Mexico',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'MH',
    name: 'Michoacan',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'MR',
    name: 'Morelos',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'NA',
    name: 'Nayarit',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'NL',
    name: 'Nuevo Leon',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'OA',
    name: 'Oaxaca',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'PU',
    name: 'Puebla',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'QA',
    name: 'Queretaro',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'QR',
    name: 'Quintana Roo',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'SL',
    name: 'San Luis Potosi',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'SI',
    name: 'Sinaloa',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'SO',
    name: 'Sonora',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'TA',
    name: 'Tabasco',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'TM',
    name: 'Tamaulipas',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'TL',
    name: 'Tlaxcala',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'VZ',
    name: 'Veracruz',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'YC',
    name: 'Yucatan',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
  {
    abbreviation: 'ZT',
    name: 'Zacatecas',
    country: 'Mexico',
    countryAbbrevation: 'MX',
  },
];
